<template>
	<!-- Modal de detalle de servicio -->
	<Dialog
		:value="value"
		:hide-footer="!canBeUpdated || currentTab != 'general'"
		@close="close()"
		@ok="submit($event)"
	>
		<template v-slot:modal-title>
			<Header />
		</template>
		<b-overlay
			:show="loading || loadingReservation"
			no-wrap
			rounded
		></b-overlay>
		<CreatedInfo
			:modelId="modelId"
			:copyFromId="copyFromId"
			class="mb-2"
			@onCopyRes="$emit('onCopyRes', $event)"
			:isCancelable="isCancelable"
		/>
		<TabsContainer @activate-tab="activeIndex">
			<b-tab title="General" active>
				<form action="#" @submit.prevent="onSubmit" ref="resForm">
					<TabGeneral
						:tsSelectedId="tsSelectedId"
						:modelId="modelId"
						:canBeUpdated="canBeUpdated"
						:copyFromId="copyFromId"
						:formTypeWork="formTypeWork"
					/>
				</form>
			</b-tab>
			<b-tab
				v-if="
					viewModel.id > 0 && $hasPermission('reservation.cost.show')
				"
				title="Costos"
			>
				<TabPrices
					v-if="
						loadedIndex.includes(
							$hasPermission('reservation.cost.show') ? 1 : 0
						)
					"
					:model-id="viewModel.id"
				/>
			</b-tab>
			<b-tab
				v-if="
					viewModel.id > 0 &&
						$hasPermission('reservation.payment.show')
				"
				title="Pagos"
			>
				<TabPayments
					v-if="
						loadedIndex.includes(
							$hasPermission('reservation.payment.show') ? 2 : 1
						)
					"
					:model-id="viewModel.id"
				/>
			</b-tab>
			<b-tab v-if="viewModel.id > 0 && !coordinatorMode" title="Cambios">
				<TabHistory
					v-if="
						loadedIndex.includes(
							$hasPermission('reservation.change.show') ? 3 : 2
						)
					"
					:model-id="viewModel.id"
				/>
			</b-tab>

			<b-tab
				v-if="
					viewModel.id > 0 &&
						$hasPermission('reservation.notification.show')
				"
				title="Notificaciones"
			>
				<TabMailHistory
					v-if="
						loadedIndex.includes(
							$hasPermission('reservation.notification.show')
								? 4
								: 3
						)
					"
				/>
			</b-tab>
		</TabsContainer>
	</Dialog>
</template>

<script>
import Dialog from "./helpers/_dialog";
import Header from "./helpers/_header";
import CreatedInfo from "./helpers/_createdInfo.vue";

//Tabs del formulario principal
import TabsContainer from "@/components/helpers/TabsContainer";
import TabGeneral from "./TabGeneral";
import TabPrices from "../../reservations/Prices";
import TabPayments from "../../reservations/payments/Single";
import TabHistory from "../../reservations/History";
import TabMailHistory from "../../reservations/notifications/Index";
import { mapActions, mapState } from "vuex";
import api from "@/api.js";
export default {
	components: {
		TabsContainer,
		Dialog,
		Header,
		CreatedInfo,
		TabGeneral,
		TabPrices,
		TabPayments,
		TabHistory,
		TabMailHistory
	},
	props: {
		coordinatorMode: Boolean,
		value: Boolean,
		tsSelectedId: {
			//Transporte service seleccionado
			type: Number,
			required: false,
			default: -1
		},
		modelId: {
			//id del la reserva, en caso de que sea nueva reserva tendra el valor de -1
			type: Number,
			required: false,
			default: -1
		},
		copyFromId: {
			// id de la reserva que se esta copiando
			type: Number,
			required: false,
			default: -1
		},
		formTypeWork: {
			//tipo de trabajo que acepta el formulario: newForm(nuevo formulario), newFormCopy(formulario en copia), viewForm(visualizar el formulario) y newFormLocationReferences(nuevo formulario con referencia de un lugar-cotizacion)
			type: String,
			required: false
		}
	},
	data() {
		return {
			loading: false,//vairable que maneja el estado de la carga
			transportServiceValidStatus: ["active", "pending"],//variable que define los tipos d estados
			currentTab: "general",
			loadedIndex: []
		};
	},

	computed: {
		...mapState("reservation", ["viewModel", "loadingReservation"]),
		canBeUpdated() {
			//devuelve true o false, para definir si la reservacion se puede actualizar o no
			return (
				//tiene permisos?
				this.$hasPermission("reservation.booking.edit") &&
				//estado de la reservacion es activo?
				this.viewModel.status == "active" &&
				//los estados de los transportservices estan definidos?
				this.viewModel.transportServices.filter(ts =>
					this.transportServiceValidStatus.includes(ts.status)
				).length > 0
			);
		},
		isCancelable() {
			//devuelve true o false, para definir si la reservacion se puede cancelar o no
			return (
				//estado de la reservacion es activo?
				this.viewModel.status == "active" &&
				//los estados de los transportservices estan son distinto de los definidos al inicio?
				this.viewModel.transportServices.filter(
					ts => !this.transportServiceValidStatus.includes(ts.status)
				).length === 0
			);
		}
	},
	methods: {
		//recuperamos las acciones vuex de reservacion
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),
		onSubmit() {
			//mostramos el proceso de carga
			this.loading = true;
			//existe un id de reserva?
			if (this.modelId > 0) {
				// actualizar
				api(this)
					.put(`/reservations/${this.viewModel.id}`, this.viewModel)
					.then(() => {
						this.loading = false;
						this.$root.showAlert("Actualización exitosa");
						this.$root.$emit(
							"bv::refresh::table",
							"reservations-index-list"
						);
						this._fetchModel({
							context: this,
							modelId: this.modelId,
							copyFromId: this.copyFromId
						});
						this.fetchNotes();
					})
					.catch(this.$root.handleRequestError)
					.finally(() => (this.loading = false));
			} else {
				//nueva reservacion
				console.log(this.viewModel);
				api(this)
					.post(`/reservations`, this.viewModel)
					.then(res => {
						this.loading = false;
						this.$root.showAlert("Reserva registrada con éxito");
						//refrescamos la tabla de la vista padre con bootstrap
						this.$root.$emit(
							"bv::refresh::table",
							"reservations-index-list"
						);
						//retornamos el id del nuevo registro de la reserva
						this.$emit("changeId", res.data.id);
					})
					.catch(this.$root.handleRequestError)
					.finally(() => (this.loading = false));
			}
		},
		activeIndex(newIndex) {
			return !this.loadedIndex.includes(newIndex)
				? this.loadedIndex.push(newIndex)
				: false;
		},
		submit(event) {
			//cancelamos el evento action del formulario
			event.preventDefault();
			//esta validado?
			if (this.$refs.resForm.checkValidity()) return this.onSubmit();
			//pide al usuario validar los campos requeridos del formulario
			this.$refs.resForm.reportValidity();
		},
		close() {
			this.loadedIndex = [];
			this.$emit("input", false);
		},
		async fetchNotes() {
			await this._fetchNotes({ context: this, modelId: this.modelId });
		},
	},
	mounted() {
		// cargar las variables auxiliares del archivo aux-var.js
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"suppliersOpts",
				"salesChannelsOpts",
				"serviceTypesOpts",
				"airportsOpts",
				"destinationsOpts",
				"usersOpts"
			]
		});
	}
};
</script>

<style>
@media (max-width: 600px) {
	.box-btns {
		display: block !important;
	}
	.box-btns button {
		margin-top: 5px;
		width: 100% !important;
	}
}
.vbst-item {
	line-height: normal;
}
.list-group-item {
	padding: 0.2rem 0.8rem;
}
.list-group {
	padding-top: 2px;
}
.vue__time-picker input.display-time {
	height: 1.95em;
}
input.display-time.all-selected.disabled {
	background-color: #e9ecef;
	color: #495057;
}

.border-success {
	border-color: #28a745 !important;
}
.border-danger {
	border-color: #dc3545 !important;
}
.border-warning {
	border-color: #ffc107 !important;
}
</style>
